import { render, staticRenderFns } from "./BObjectTreeview.vue?vue&type=template&id=076e28eb"
import script from "./BObjectTreeview.vue?vue&type=script&lang=js"
export * from "./BObjectTreeview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports